import { ActivityTypes as GameActivityType } from '@monorepo/shared/src/providers/GameProvider/types';

export enum StoreTypename {
  GUESS_THE_ORDER_ACTIVITY = 'Guess The Order Activity',
  GUESS_WHERE_ACTIVITY = 'Guess Where Activity',
  GUESS_WHO_ACTIVITY = 'Guess Who Activity',
  FEELINGS_MATCH_ACTIVITY = 'Feelings Match Activity',
  MATCH_IT_TRASH_IT_ACTIVITY = 'Match It Trash It Activity',
  STARTING_SOUND_ACTIVITY = 'Starting Sound Activity',
  UI = 'Store.Ui',
  USER = 'User',
  ASSIGNMENTS = 'assignments',
  WDT_ACTIVITY = 'Wet Dry Try Activity',
  READING_LOGS = 'Reading Logs',
  AFFIRMATIONS = 'Affirmations',
  STUDENT_PROGRESS = 'Student Progress',
}

export enum ButtonSize {
  XLARGE = 140,
  LARGE = 120,
  MEDIUM = 100,
  SMALL = 80,
  XSMALL = 70,
}

export enum TYPOGRAPHY_TYPES {
  ASCENDER = 'ascender',
  DESCENDER = 'descender',
  PLAIN = 'plain',
}

export enum SCREEN_RESIZE_MEDIA_QUERY {
  IPAD = '(max-width:1024px)',
}

export enum AppRoutes {
  ASSIGNMENTS = 'assignments',
  ASSIGNMENT_ACTIVITIES = 'assignment-activities',
  LETTER_BOOKS = 'letter-books',
  READ_BOOK = 'read-book',
  PRACTICE_BOOK = 'practice-book',
  TEACHERS_GUIDE = 'teachers-guide',
  RESOURCES = 'resources',
  TOUR = 'tour',
  ONBOARDING = 'onboarding',
  ACTIVITIES = 'activities',
  CLASSROOM_BOOKS = 'classroom-books',
  REWARDS = 'rewards',
  REPORTS = 'reports',
  HOME = 'home',
  ACTIVITY_COMPLETE = 'activity-complete',
}

export enum ActivityTypes {
  GUESS_THE_ORDER = 'guess-the-order',
  GUESS_WHERE = 'guess-where',
  GUESS_WHO = 'guess-who',
  FEELINGS_MATCH = 'feelings-match',
  MATCH_IT_TRASH_IT = 'match-it-trash-it',
  STARTING_SOUND = 'starting-sound',
  FIND_THE_LETTER = 'find-the-letter',
  FIND_THE_OBJECTS = 'find-the-objects',
  PRACTICE_BOOK = 'practice-book',
  WDT = 'wet-dry-try',
}

export type SharedActivityData = {
  [type in ActivityTypes.FIND_THE_LETTER | ActivityTypes.FIND_THE_OBJECTS]: {
    activity: GameActivityType;
    Footer?: React.FC;
    Content: React.FC;
    Header?: React.FC;
  };
};

export enum ButtonTypes {
  HOME_BUTTON = 'homeButton',
  REWARD_BUTTON = 'rewardsButton',
  BACK_BUTTON = 'backButton',
  CLOSE_BUTTON = 'closeButton',
  MAT_MAN_BUTTON = 'matManButton',
  MAT_MAN_ACTIVITY_BUTTON = 'matManActivityButton',
  ACCESSIBILITY_BUTTON = 'accessibilityButton',
  FOR_FAMILIES_BUTTON = 'forFamiliesButton',
  FAMILY_RESOURCES_BUTTON = 'familyResourcesButton',
  LOGOUT_BUTTON = 'logoutButton',
}

export enum Settings {
  ONBOARDING = 'onboarding',
}
